import { Size } from '../../../../core/types/ui/size';
import { IPosition2d } from '../../../../core/types/ui/position';
import { Box, Icon, Tooltip, filter } from '@chakra-ui/react';
import numeral from 'numeral';
import './columnFilterStyles.scss';
import {
  MdFilterAlt,
  MdFilterAltOff,
  MdOutlineFilterList,
} from 'react-icons/md';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';

interface ColumnFilterrRootProps
  extends Size,
    IPosition2d,
    Pick<UseSheetTheme, 'filterAppliedFill' | 'secondaryFill' | 'stroke'> {
  count: number;
  hasFilter: boolean;
  zoom: number;
}

const ColumnFilterRoot: React.FC<ColumnFilterrRootProps> = ({
  x,
  y,
  width,
  height,

  filterAppliedFill,
  secondaryFill,
  stroke,

  zoom,

  hasFilter,
  count,
}) => {
  // const isFilterApplied = false;

  // let totalResults = 1000312;
  const formattedResults = numeral(count).format('0a');
  const label = hasFilter
    ? `${count} filtered row${count !== 1 ? 's' : ''}`
    : '';

  const renderFilterIcon = () =>
    hasFilter ? (
      <>
        <Icon
          as={MdFilterAltOff}
          color={'#fff'}
          className="clear_filter_icon"
        />
        <Box
          className="total_filter_results"
          fontSize={12 * zoom}
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontWeight="bold"
        >
          {formattedResults}
          <Icon
            as={MdOutlineFilterList}
            marginLeft="2px"
            className="clear_filter_icon"
            size={`${5 * zoom}px`}
          />
        </Box>
      </>
    ) : (
      <Icon as={MdFilterAlt} opacity={0.7} />
    );

  return (
    <Tooltip label={label} p={3} borderRadius={10} placement="top">
      <Box
        left={`${x}px`}
        top={`${y}px`}
        width={`${width}px`}
        height={`${height}px`}
        background={secondaryFill} // hasFilter ? filterAppliedFill : secondaryFill
        border={`${1 * zoom}px solid ${stroke}`}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
        // padding="2px"
        cursor={hasFilter ? 'pointer' : 'default'}
        className={hasFilter ? 'column-filter-root' : ''}
        transition="all .2s ease-in-out"
        overflow="hidden"
        zIndex={1}
      >
        {renderFilterIcon()}
      </Box>
    </Tooltip>
  );
};

export default ColumnFilterRoot;
